import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ActionButton from './ActionButton';
import React, { Fragment } from 'react';
import { makeStyles } from '@mui/styles';
import { useRoundware } from '../../hooks';
import Container from '@mui/material/Container';

import banner from '../../assets/rw-icon-cluster.png';
import { GeoListenMode } from 'roundware-web-framework';
import useStyles from './styles';
import config from 'config';
import logo from '../../assets/ra-logo-large-asset-wo.png'; 
import subtitle from '../../assets/subtitle-asset-wo.png'; 
import blackmap from '../../assets/listen-map-asset-grid-no-listen-wo.png'; 
import shareBtn from '../../assets/share-asset-button.png'; 
import shareBck from '../../assets/share-no-text.png'; 
import infoBck from '../../assets/info-black-no-text.png'; 
import infoBtn from '../../assets/information-asset-button.png'; 


export const LandingPage = () => {
	const { roundware, forceUpdate } = useRoundware();
	const classes = useStyles();

	const project = roundware.project;
	if (!project || project.projectName === '(unknown)') {
		return null;
	}

	return (
		<Container style={{ paddingRight: 0, paddingLeft: 0 }}>
			<Grid container className={classes.landingHeader}>
{/*				<Grid container justifyContent='center' style={{ height: '100px', outline:'1px solid blue'}}>
					<Grid
						item
						style={{ margin: 'auto', height: '15vh', textAlign: 'center', paddingTop: 15, marginTop: 100, outline:'1px solid blue' }}
						sm={12}
					>
						<Typography
              variant={"h2"}
              className={classes.landingTitle}
            >
              {roundware.project && roundware.project.projectName}
            </Typography>
						<img src={banner} className={classes.landingBanner} />
					</Grid>
					<Grid item sm={12}>
						<Typography variant={'subtitle1'} className={classes.landingTagline} style={{ textAlign: 'center', height: '15vh' }}>
							Contributory Audio Augmented Reality
							<br />
							for Art, Education and Documentary
						</Typography>
					</Grid>
				</Grid>*/}

				<Grid container justifyContent='center' style={{ margin:'100px auto', minWidth:'300px', maxWidth:'600px'}}>
					<Grid item sm={12}>
						<img alt='Radical Atmospheres'src={logo} style={{maxWidth:'100%'}}/> 
						
					</Grid>


					<Grid item sm={12}>
						<img style={{maxWidth:'100%'}} alt='Visions of Liberation, Tactics of Supression, Puerto Rican activism in East Harlem'src={subtitle}/> 
					</Grid>

					{project.data?.listen_enabled && (

						<Grid item style={{position:'relative'}} sm={12}>
							<img src={blackmap} style={{maxWidth:'100%'}}/> 

							<ActionButton
								onClick={() => {
									if (!config.listen.autoplay) return;
									if (!roundware.mixer || !roundware.mixer?.playlist) {
										roundware?.activateMixer({ geoListenMode: GeoListenMode.MANUAL }).then(() => {
											if (roundware && roundware.uiConfig && roundware.uiConfig.listen && roundware.uiConfig.listen[0]) {
												const listen_tags = roundware.uiConfig.listen[0].display_items.map((i) => i.tag_id);
												roundware.mixer.updateParams({
													listenerLocation: roundware.listenerLocation,
													minDist: 0,
													maxDist: 0,
													recordingRadius: 0,
													listenTagIds: listen_tags,
												});
												roundware.mixer.play();
												forceUpdate();
											}
										});
									} else {
										roundware.mixer.play();
										forceUpdate();
									}
								}}
								label={'Listen'}
								linkTo={'/listen'}
								style={{ width: '100%',zIndex:'1', top:'0', marginTop:'9%', position: 'absolute' }}
							/>
						</Grid>
					)}

					<Grid item style={{position:'relative'}} sm={12}>
						<img src={infoBck} style={{maxWidth:'100%'}}/> 
						<div style={{ width: '100%',zIndex:'1', top:'0', bottom:'0',position: 'absolute', display:'flex'}}>
							<div style={{ display: 'flex', margin: 'auto' }}>
								<a style={{ display: 'flex' }} href="https://radicalatmospheres.net/">
									<img src={infoBtn} style={{ maxWidth:'33%', margin:'auto' }}/> 
								</a>
							</div>
						</div>
					</Grid>

{/*					<Grid item style={{position:'relative'}} sm={12}>
						<img src={shareBck} style={{maxWidth:'100%'}}/> 
						<div style={{ width: '100%',zIndex:'1', top:'0', bottom:'0',position: 'absolute', display:'flex'}}>
						<img src={shareBtn} style={{maxWidth:'10%', margin:'auto'}}/> 
							</div>
					</Grid>*/}

{/*					{project.data?.speak_enabled && (
						<Grid item>
							<ActionButton label={'Speak'} linkTo={'/speak'} />
						</Grid>
					)}*/}
				</Grid>
			</Grid>
		</Container>
	);
};
